// extracted by mini-css-extract-plugin
export default {"nav_main":"_2tTY","header_main":"_2VDf","header_content":"R1nN","header_logo":"_1Y4K","header_link":"_25mG","header_wrapper":"_3wXT"};